import React, { useEffect, useState } from 'react';
import {toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import axios from 'axios';
import Navbar from '../../Navbar';

const TicketForm = () => {
    const [userData, setUserData] = useState({});
    const [empcode, setEmpcode] = useState('');
    const [empname, setEmpname] = useState('');
    const [emailid, setEmailid] = useState('');
    const [title, setTitle] = useState('');
    const [category, setCategory] = useState('');
    const [subcategory, setSubcategory] = useState('');
    const [stage, setStage] = useState('');
    const [impact, setImpact] = useState('');
    const [priority, setPriority] = useState('');
    const [assets, setAssets] = useState('');
    const [assignagent, setAssignagent] = useState('');
    const [dueby, setDueby] = useState('');
    const [assigningdepartment, setAssigningdepartment] = useState('');
    const [description, setDescription] = useState('');
    const navigate = useNavigate();


  

  const handleSubmit = (e) => {
    e.preventDefault();
    // if(!empcode || !empname || !emailid || !title || !category || !subcategory || !stage || !impact || !priority || !assigningdepartment || !description)
    // {
    //     return toast.error("Please select some fields missing", { position: "top-center" });
    // }
    const newTicket = { empcode, empname, emailid, title, category, subcategory, stage, impact, priority, assets, assigningdepartment, assignagent, dueby, description };    
    axios.post('/ticketDetails/api/v1/api/newtickets', newTicket)
      .then(response => {        
        console.log('Ticket Created:', response.data);
        setTitle('');
        setDescription('');
      })
      .catch(error => console.error('There was an error creating the ticket!', error));
  };


  const empdataHomePage = async () => {
    try {
        const res = await fetch('/user/empmasterdata');
        const empdata = await res.json();        
        setUserData(empdata);         
    } catch (err) {
        console.log(err);
        
    }

}  

const pagauth = async() => {
    const pageids = "itsmcreateticket";
    const res = await fetch('/user/pageaccessdatas/'+ pageids, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      credentials: "include"
    })    
    if(res.status === 404)
    {
      navigate('/Home');
      toast.error("You don't have access this page.", { position: "top-center" });
    }
  }




  useEffect (() => {
    pagauth();
    empdataHomePage();        
    
  }, []);

  

  return (
    <>
 <div className="">
    <Navbar />
</div>
    <div className='d-flex justify-content-center align-items-left bg-white vh-100 mt-5'>
    
    <div className='bg-secondary p-3 rounded w-75'>
    
    <h4>Submit New Ticket</h4>
    <div className='mb-3 text-bg-success text-left form-control-sm rounded-3'>
      <form onSubmit={handleSubmit}>

    <div className="row">
    <div className="col">
    <label for="inputRequesterEmpCode" className="form-label">Requester Emp Code *</label>
    <input type="text" className="form-control" placeholder="Requester Emp Code" id="inputRequesterEmpCode"
    value={userData.empCode}
    onChange={(e) => setEmpcode(e.target.value)} />
  </div>  
  <div className="col">
    <label for="inputRequesterEmpName" className="form-label">Requester Emp Name *</label>
    <input type="text" className="form-control" placeholder="Requester Emp Name" id="inputRequesterEmpName"
    value={userData.empName} />
  </div>  
  <div className="col">
    <label for="inputRequesterEmailId" className="form-label">Requester Email Id *</label>
    <input type="text" className="form-control" placeholder="Requester Email Id" id="inputRequesterEmailId"
    value={userData.emailid} />
  </div>  
</div>

<div className="row">
  <div className="col">
    <label for="inputTicketTitle" className="form-label">Subject / Titel *</label>
    <input type="text" className="form-control" placeholder="Ticket Title" id="inputTicketTitle"
    value={title}
    onChange={(e) => setTitle(e.target.value)} />
  </div>
  
</div>

<div className="row">
<div className="col">
    <label for="selectCategory" className="form-label">Category *</label>
    <select class="form-select" id="selectCategory">
      <option selected>Choose...</option>
      <option value="1">SoftWare</option>
      <option value="2">HardWare</option>
      <option value="3">Email</option>
      <option value="4">Other</option>
    </select>
  </div>
  <div className="col">
    <label for="selectSubCategory" className="form-label">Sub Category/Issue Type *</label>
    <select class="form-select" id="selectSubCategory">
      <option selected>Choose...</option>
      <option value="1">Printer</option>
      <option value="2">Battery</option>
      <option value="3">Password Reset</option>
      <option value="4">Other</option>
    </select>
  </div>
  <div className="col">
    <label for="selectStage" className="form-label">Stage *</label>
    <select class="form-select" id="selectStage">
      <option selected>Choose...</option>
      <option value="1">Level_1</option>
      <option value="2">Level_2</option>
      <option value="3">Level_3</option>
      <option value="4">Level_4</option>
    </select>
  </div>
</div>

<div className="row">
  <div className="col">
    <label for="selectImpact" className="form-label">Impact *</label>
    <select class="form-select" id="selectImpact">
      <option selected>Choose...</option>
      <option value="1">Low</option>
      <option value="2">Medium</option>
      <option value="3">High</option>
    </select>
  </div>
  <div className="col">
    <label for="selectPriority" className="form-label">Priority *</label>
    <select class="form-select" id="selectPriority">
      <option selected>Choose...</option>
      <option value="1">Low</option>
      <option value="2">Medium</option>
      <option value="3">High</option>
    </select>
  </div>
  <div className="col">
    <label for="inputAssets" className="form-label">Assets *</label>
    <input type="text" className="form-control" placeholder="Assets" id="inputAssets"/>
  </div>
  
</div>


<div className="row">
<div className="col">
    <label for="selectAssignDepartment" className="form-label">Assigning Department *</label>
    <select class="form-select" id="selectAssignDepartment">
      <option selected>Choose...</option>
      <option value="1">Finance</option>
      <option value="2">Treasury</option>
      <option value="3">Logestics</option>
      <option value="4">Planning</option>
      <option value="5">Purchase</option>
      <option value="6">HR</option>
      <option value="7">Digital</option>
      <option value="8">FFM</option>
      <option value="9">Sales</option>
      <option value="10">Marketing</option>
      <option value="11">IT</option>
    </select>
  </div>
  <div className="col">
    <label for="inputAssignAgent" className="form-label">Assign Agent *</label>
    <input type="text" className="form-control" placeholder="Assign Agent" id="inputAssignAgent" />
  </div>
  <div className="col">
    <label for="inputDueBy" className="form-label">Due By *</label>
    <input type="datetime-local" className="form-control" placeholder="Due By" id="inputDueBy" />
  </div>
</div>


<div className="row">
  
  
</div>   

<div className="row">
  <div className="col">
    <label for="textareaDecription" className="form-label">Description *</label>
    <textarea className="form-control" placeholder="Ticket Description" id="textareaDecription"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
  </div>  
</div>        
        
        <div class="col-auto text-center mt-2">
    <button type="submit" class="btn btn-primary">Submit Ticket</button>
  </div>
        
      </form>
    </div>
    </div>
    </div>
    </>
  );
};

export default TicketForm;
